<template>
  <div class=" tw-h-full tw-w-full tw-p-2 tw-h-svh lg:tw-p-4 light lighten-4">
    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-w-full tw-h-full">
      <div class="tw-w-full lg:tw-w-2/5 tw-flex tw-flex-col tw-gap-2 tw-justify-between primary tw-p-8 xl:tw-p-12 tw-rounded-md tw-h-full">
        <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-gap-12">
          <img class="tw-w-24" src="../../assets/logo.svg" alt="Kitchenly Logo" />
          <div class="tw-flex tw-flex-col tw-gap-2 xl:tw-gap-6">
            <span class="tw-w-3/4 tw-text-3xl tw-font-semibold tw-leading-tight lg:tw-text-4xl light--text lg:tw-w-1/2 md:tw-w-1/3">Transform Your Nutrition Management</span>
            <span class="light--text tw-text-sm text--lighten-2">
              Unlock the full potential of your dietary planning with our cutting-edge Diet ERP application. Designed for nutritionists, dietitians, and food service managers, our platform streamlines
              meal planning, inventory management, and nutritional analysis.
            </span>
          </div>
        </div>

        <div class="tw-w-full lg:tw-hidden tw-block lg:tw-w-3/5 light tw-rounded-md tw-p-4">
          <UserSignInForm />
        </div>
      </div>
      <div class="tw-w-full tw-hidden lg:tw-block lg:tw-w-3/5 tw-p-14">
        <UserSignInForm />
      </div>
    </div>
  </div>
</template>

<script>
import UserSignInForm from "@/user/components/UserSignInForm.vue";

export default {
  components: {
    UserSignInForm,
  },
};
</script>

<style></style>
